import { useEffect, useMemo, useState } from 'react';
import Seo from '../../components/Seo/Seo';
import { useNavigate } from 'react-router-dom';
import { getProducts, type Product } from '../../api/products';
import { useCartContext } from '../../context/CartContext';
import AkkuBox from '../../components/AkkuBox/AkkuBox';

const BUCKETS = [
	{ label: '44', min: 44, max: 54 },
	{ label: '55', min: 55, max: 73 },
	{ label: '74', min: 74, max: 99 },
	{ label: '100', min: 100, max: 100000 },
];

export default function ArlistaPage() {
	const [products, setProducts] = useState<Product[]>([]);
	const [loading, setLoading] = useState(true);
	const { addToCart } = useCartContext();
	const navigate = useNavigate();

	useEffect(() => {
		let active = true;
		setLoading(true);
		getProducts({ type: 1 })
			.then((res) => {
				if (!active) return;
				const raw = (res.data?.data || []) as Product[];
				setProducts(raw.map((p) => ({ ...p, price: Number(p.price), voltage: Number(p.voltage), capacity: Number(p.capacity), cca: Number(p.cca) })));
			})
			.catch(() => active && setProducts([]))
			.finally(() => active && setLoading(false));
		return () => { active = false; };
	}, []);

	const grouped = useMemo(() => {
		const usable = products.filter((p) => p.voltage > 0 && p.cca > 0);
		return BUCKETS.map((b) => ({
			...b,
			items: usable
				.filter((p) => p.capacity >= b.min && p.capacity <= b.max)
				.sort((a, c) => a.capacity - c.capacity || a.brand.localeCompare(c.brand)),
		}));
	}, [products]);

	function order(product: Product) {
		addToCart({ productId: product.id, name: product.name, price: Number(product.price), image: product.image, quantity: 1 });
		navigate('/megrendeles');
	}

	return (
		<div className="arlista">
			<Seo
				title="Árlista - Akku 24+"
				description="Akkumulátor árlista kapacitás szerint csoportosítva: 44, 55, 74 és 100 Ah akkumulátorok specifikációkkal és árakkal."
			/>

			<div className="container">
				<div className="arlista__head">
					<h1>Árlista</h1>
					<p>Akkumulátoraink kapacitás szerint. A kiszállási díj (14.500 Ft) tartalmazza a helyszíni cserét, bevizsgálást és a használt akku elszállítását.</p>
				</div>

				<nav className="listnav">
					{BUCKETS.map((b) => <a key={b.label} href={`#ah${b.label}`}>{b.label} Ah</a>)}
				</nav>

				{loading && <p className="note">Akkumulátorok betöltése…</p>}

				{!loading && grouped.map((g) => (
					<section key={g.label} id={`ah${g.label}`}>
						<div className="ahLabel">{g.label} Ah</div>
						{g.items.length === 0 ? (
							<p className="note">Ebben a kategóriában jelenleg nincs elérhető akkumulátor.</p>
						) : (
							<div className="akkulist">
								{g.items.map((p) => <AkkuBox key={p.id} product={p} onOrder={order} />)}
							</div>
						)}
					</section>
				))}
			</div>
		</div>
	);
}
